import { render, staticRenderFns } from "./pax-widget.vue?vue&type=template&id=5e45585d&scoped=true"
import script from "./pax-widget.vue?vue&type=script&lang=js"
export * from "./pax-widget.vue?vue&type=script&lang=js"
import style0 from "./pax-widget.vue?vue&type=style&index=0&id=5e45585d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e45585d",
  null
  
)

export default component.exports